import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import React from 'react'
import './index.scss'

export interface BulkAmendmentConfirmationPopupProps {
    onClose: () => void
}

const BulkAmendmentConfirmationPopup = (props: BulkAmendmentConfirmationPopupProps) => {
    const { onClose } = props
    return (
        <Popup onClose={onClose}>
            <ConfirmationPopup
                title="Your share amendment has been submitted"
                popupClassName="bulk-amendment-confirmation-popup"
                onConfirm={onClose}
                confirmButtonText="Done"
            >
                <span>
                    You can see the status of your submission under the 'Pending' tab of the 'Registration History'
                    page.
                </span>
            </ConfirmationPopup>
        </Popup>
    )
}
export default BulkAmendmentConfirmationPopup
